<nz-layout>
  <nz-layout>
    <nz-sider></nz-sider>
    <nz-content *ngIf="!isIntelligenceSuite && !isInventory" class="layout" nz-col nzSm="24" nzXs="24" nzMd="24" nzLg="12" nzXl="12">
      <div *ngIf="showHeaderMenu" class="internationalize" nz-row>
        <!-- <div class="duty-calc" nz-column>
          <i nz-icon nzType="link" nzTheme="outline"></i>
          <a nz-dropdown [nzDropdownMenu]="menu">
            Useful Links
            <i nz-icon nzType="down"></i>
          </a>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu nzSelectable>
              <li id="dutyCalculator" nz-menu-item (click)="landingCostCalculator()"><i style="margin: 0 4px 0 0" nz-icon nzType="calculator" nzTheme="outline"></i>
                  {{'app.login.calculate-landing' | translate}}</li>
              <li id="dutyCalculator" nz-menu-item (click)="ftaAdvisor()"><i style="margin: 0 4px 0 0" nz-icon nzType="solution" nzTheme="outline"></i>
                  {{'app.login.fta-advisor' | translate}}</li>
            </ul>
          </nz-dropdown-menu>
          <span class="divider" >|</span>
        </div> -->
        <!-- <div [hidden]="isCommonResourceLoaded">
          <header-i18n [showLangText]="true" class="langs"></header-i18n>
        </div> -->
      </div>
      <div class="mob-header">
        <div class="logo">
          <!-- <img/> -->
        </div>
        <div [hidden]="isCommonResourceLoaded" class="internationalize2">
          <header-i18n *ngIf="showHeaderMenu" [showLangText]="true" class="langs"></header-i18n>
        </div>
      </div>
      <div [hidden]="isCommonResourceLoaded">
        <router-outlet></router-outlet>
      </div>
      <nz-spin class="resource-loader" nzTip="Loading..." [hidden]="!isCommonResourceLoaded">
      </nz-spin>
    </nz-content>
    <nz-content *ngIf="!isUserAdmin && !isIntelligenceSuite && !isInventory" class="layout-pic" nz-col nzSm="24" nzXs="24" nzMd="24"
      nzLg="12" nzXl="12">
      <div class="logo"></div>
    </nz-content>
    <nz-content nz-row *ngIf="isIntelligenceSuite">
      <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12" >
        <div class="grid-config" nz-row class="intelligence-suite-language" nzJustify="end">
          <div nz-col nzSpan="8"></div>
          <header-i18n  [showLangText]="true" class="langs"></header-i18n>
        </div>
        <div nz-row nzJustify="center" >
          <div class="intelligence-suite-login" nz-col nzSpan="14">
          <router-outlet></router-outlet>
        </div>
        </div>
      </div>
      <nz-carousel class="gutter-row"  nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12" [nzEffect]="'scrollx'" [nzDotPosition]="'bottom'" nzAutoPlay>
        <div class="grid-config"  nz-carousel-content *ngFor="let index of intelligenceArray">
            <img  class="layout-intelligence-suite-carousel-img" [src]="index"/>
        </div>
      </nz-carousel>

    </nz-content>
    <nz-content nz-row *ngIf="isInventory">
      <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12" >
        <div class="grid-config" nz-row class="inventory-ui-language" nzJustify="end">
          <div nz-col nzSpan="8"></div>
          <header-i18n  [showLangText]="true" class="langs"></header-i18n>
        </div>
        <div nz-row nzJustify="center" >
          <div class="inventory-ui-login" nz-col nzSpan="14">
          <router-outlet></router-outlet>
        </div>
        </div>
      </div>
      <nz-carousel class="gutter-row"  nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12" [nzEffect]="'scrollx'" [nzDotPosition]="'bottom'" nzAutoPlay>
        <div class="grid-config"  nz-carousel-content *ngFor="let index of inventoryArray">
            <img  class="layout-inventory-ui-carousel-img" [src]="index"/>
        </div>
      </nz-carousel>

    </nz-content>
  </nz-layout>
  <nz-footer [hidden]="isCommonResourceLoaded">
    <app-footer></app-footer>
  </nz-footer>
</nz-layout> 

<!-- <app-build-info-button></app-build-info-button> -->
